import shortenNumber from '@wix/da-shared-react/pkg/utils/shortenNumber';

const getStatLine = (t: Function, entity: string, count?: number) => {
  const formattedCount = count && shortenNumber(count);
  return count
    ? t(`common.stats.${entity}`, {
        count,
        formattedCount,
      })
    : '';
};

export default getStatLine;
